<div class="headerdiv"></div>
<div class="static-options-wrapper">
  <div class="dropdown-menu static-links-dropdown-wrapper">
    <ul class="static-links-list">
      <a [attr.href]="staticURL?.cateringForBuilding" target="_blank" *ngIf="staticURL?.cateringForBuilding">
        <li>
          <div>
            <span class="text">{{ "Translation.Addcatering" | translate }}<span class="icon-external-link-default-14 icon"></span></span>
          </div>
        </li>
      </a>
      <a [attr.href]="staticURL?.hotelingUrl" target="_blank" *ngIf="staticURL?.hotelingUrl">
        <li>
          <div>
            <span class="text"
              >{{ "Translation.Conciergeresourcecenter" | translate }}<span class="icon-external-link-default-14 icon"></span
            ></span>
          </div>
        </li>
      </a>
      <a [attr.href]="staticURL?.magnetProfileUrl" target="_blank" *ngIf="staticURL?.magnetProfileUrl">
        <li>
          <div>
            <span class="text">{{ "Translation.Magnet" | translate }}<span class="icon-external-link-default-14 icon"></span></span>
          </div>
        </li>
      </a>
      <a [attr.href]="staticURL?.reportsUrl" target="_blank" *ngIf="staticURL?.reportsUrl">
        <li>
          <div>
            <span class="text">{{ "Translation.Reports" | translate }}<span class="icon-external-link-default-14 icon"></span></span>
          </div>
        </li>
      </a>
      <a [attr.href]="staticURL?.serviceOrderReports" target="_blank" *ngIf="staticURL?.serviceOrderReports">
        <li>
          <div>
            <span class="text"
              >{{ "Translation.Serviceorderreports" | translate }}<span class="icon-external-link-default-14 icon"></span
            ></span>
          </div>
        </li>
      </a>
      <a [attr.href]="staticURL?.serviceNowUrl" target="_blank" *ngIf="staticURL?.serviceNowUrl">
        <li>
          <div>
            <span class="text"
              >{{ "Translation.Submitchangerequests" | translate }}<span class="icon-external-link-default-14 icon"></span
            ></span>
          </div>
        </li>
      </a>
    </ul>
    <div class="divider"></div>
    <div [style.padding]="'10px'">
      <app-owner-search  [label]="'Translation.Delegation' | translate"
                         [placeholder]="'Translation.Place_holder' | translate"
                         [isExternal]="true"
                         [useAssignee]="false"
                         [showChips]="false"
                         (selected)="delegateselect($event)"
                        ></app-owner-search>
    </div>
  </div>
</div>
